import styled from 'styled-components';

import {buttonReset, colors} from 'theme';

import {Tag} from '../../ui-kit/Tags';

export const DataTitle = styled.div`
    color: ${colors.textPrimary};
    font-weight: bold;
    font-size: 14px;
    line-height: 16px;
    margin-bottom: 30px;
`;

export const ErrorsWrapper = styled.div`
    display: flex;
    flex-flow: column nowrap;
    align-items: flex-start;
    margin-bottom: 20px;
    margin-top: -24px;
`;

export const Error = styled(Tag)`
    padding: 8px 16px;
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    color: ${colors.white};
    background-color: ${colors.danger};
    border-radius: 6px;
    width: auto;
`;

export const AttachmentsWrapper = styled.div`
    margin-top: 24px;
`;

export const AttachmentsTitle = styled.div`
    margin-bottom: 8px;
    color: ${colors.textSecondary};
    font-size: 13px;
    line-height: 14px;
`;

export const AttachmentsList = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
`;

export const AttachmentButton = styled.button`
    ${buttonReset};

    display: flex;
    align-items: center;
    gap: 8px;
    max-width: 100%;
    padding: 6px 10px;
    border-radius: 6px;
    color: ${colors.textPrimary};
    background: ${colors.brandLight};
    font-size: 13px;
    font-weight: 500;
    line-height: 16px;

    &:not(:disabled):hover {
        color: ${colors.brandPrimary};
    }

    &:disabled {
        cursor: default;
        opacity: 0.5;
    }
`;

export const AttachmentName = styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
